"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkRoles = void 0;
const role_1 = require("../../src/models/role");
const checkRoles = (user, requiredRoles) => {
    const rolesAsRoleObjects = requiredRoles.map((role) => role_1.Role.createRoleFromString(role));
    return role_1.Role.validateUserPermissions(user, rolesAsRoleObjects);
};
exports.checkRoles = checkRoles;
//# sourceMappingURL=index.js.map